import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { UpdateStatusCommand } from './update-status.command';
import { UpdateStatusResult } from './update-status.result';

@Injectable({ providedIn: 'root' })
export class UpdateStatusUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(id: string, command: UpdateStatusCommand): Observable<UpdateStatusResult> {
    this.state.setSaving(true);
    this.state.clearErrorSavingStatus();

    return this.repository.updateStatus(id, command).pipe(
      map(() => ({ success: true })),
      catchError((error) => {
        this.state.setErrorSavingStatus(error.message || 'Failed to update status');
        throw error;
      }),
      finalize(() => {
        this.state.setSaving(false);
      }),
    );
  }
}
